export const initialState = {
  error: null, // sample value = { error: { message: "" }, errorInfo: { componentStack: "" } }
};
